import {RateScheduleEdit} from "./rate_schedule_edit";
import {InvoiceViewer} from "./invoice_viewer";
import { GroupAddresses } from "./group_addresses";
import { CallSourceBilling } from "./callsource_billing";
import {PaymentMethods} from "../accounting/current_billing_info/payment_methods";
import {StripeCustomerSignup} from "../accounting/stripe_customer_signup";

export class BillingManager extends HTMLElement {
  constructor(data, is_admin) {
    super();
    this.is_admin = is_admin;
    this.data = data;
  }
  
  async connectedCallback() {

    /* 
      special logic for sub groups.
      If parent_auto_group_id > 0, then we are working with a sub group.
      Only show the My Plans tab when
        sub group billing type = "Bill group separately" (value = 1)

      My Plan tab is active when:
      1. parent_auto_group_id is null (parent group)
      or
      2. parent_auto_group_id > 0 and billing type = "Bill group separately"
    */
    const is_parent_group = (this.data.parent_auto_group_id === null) 
    const is_sub_group = ! is_parent_group
    
    let my_tab_is_active = true 
    if (is_sub_group) {
      my_tab_is_active = (this.data.billing_type_id === 1)
    }

    // A stripe customer id is a string that looks like "cus_Mh51RsundRqTeA"
    const is_stripe_customer = true;//(typeof this.data.stripe_customer_id === "string" && this.data.stripe_customer_id.trim().length > 0)
    
    this.innerHTML = 
      `<style>
        a {
          cursor: pointer;
        }
        .dt-center {
          text-align: center;
        }

        .group-user-email {
          width: 20%;
        }

        .group-user-name, .group-user-action {
          width: 10%;
        }

        .group-user-remove {
          color: red;
        }

        .group-user-edit, .group-user-remove, .resend-invitation {
          cursor: pointer;
        }

        group-users .dataTables_length, group-users .dataTables_filter {
          display: none;
        }
        
        group-users .has-search {
          position: relative;
          margin: auto 20px;
        }
        
        group-users .has-search .form-control {
          padding-left: 2.375rem;
        }
        
        group-users .has-search .form-control-feedback {
            position: absolute;
            left: 2px;
            top: 2px;
            font-size: 20px;
            z-index: 2;
            display: block;
            width: 2.375rem;
            height: 2.375rem;
            line-height: 2.375rem;
            text-align: center;
            pointer-events: none;
            color: #aaa;
        }

        // tab styles
        #group_management_body .nav-tabs, #group_management_body .nav-tabs.nav-justified {
            margin-top: -35px;
            margin-left: 10px;
        }
        #group_management_body ul.nav {
            background: #FFF !important;
            width: 100%;
        }
        #group_management_body .nav-tabs > li.active > a, #group_management_body .nav-tabs > li.active > a:hover, #group_management_body .nav-tabs > li.active > a:focus, #group_management_body .nav-tabs > .dropdown.active.open > a:hover, #group_management_body .nav-tabs > li > a:hover {
            color: #003E80 !important;
        }
        #group_management_body .nav-tabs > li > a {
            border-bottom: none;
            color: grey !important;
            border: none;
            background-color: white !important;
        }
        // tab styles

        #invoice_viewer {
          display:none;
        }

        #rate_schedule_viewer {
          display:none;
        }

        .contact_address_container {
          padding-top: 12px;
        }

        .billing_address_container {
          padding-top: 12px;
        }

        .update_bill_row {
          padding-left: 8px;
        }

        @media only screen and (min-width: 1200px) {
          .contact_address_container {
            padding: 20px !important;
          }
          .billing_address_container {
            padding: 20px !important;
          }
          .billing_section {
            padding: 20px !important;
          }
          .update_bill_row {
            padding-left: 20px;
          }
        }

        #tablist3 {
          margin: 0 0 20px 0 !important;
          border: none !important;
        }

      </style>

      <!-- tabs -->
      <div class="panel-default nav">
          <ul class="nav nav-secondary nav2-subtabs page-content-wrap" role="tablist" id='tablist' style="margin-top: 0px">
            <!--
            <li class="active"><a href="#current_billing_tab" role="tab" data-toggle="tab">Current Billing</a></li>
            -->

            <li class=${my_tab_is_active ? "active" :"hide"}>
              <a href="#my_plan" role="tab" data-toggle="tab">My Plan</a>
            </li>

            <li><a href="#payment_history" role="tab" data-toggle="tab">Payment History</a></li>
            
            <!--
              <li><a href="#usage_report" role="tab" data-toggle="tab">Usage Report</a></li>
              <li><a href="#rate_schedules_tab" role="tab" data-toggle="tab">Rate Schedules</a></li>
            -->

            <li><a href="#payment_method_tab" role="tab" data-toggle="tab">Payment Methods</a></li>

            <li class=${! my_tab_is_active ? "active" :""}>
              <a href="#billing_settings_tab" role="tab" data-toggle="tab">Billing Settings</a>
            </li>
          </ul>
      </div>

    <div class="panel-body tab-content">
      <!--
      <div class="tab-pane" id="current_billing_tab">
        <div id="group_editor_billing_info_container">
            <current-billing-info-boxes 
              group_id = ${this.recordId()}
            ></current-billing-info-boxes>
          <div id="current_billing_plan_container"></div>
          <div id="group_editor_billing_rate_schedule_cards_container" style="padding:10px 0px;"></div>
        </div>
        <div id="simple_payment_history_container"></div>
        <div id="payment_methods_container"></div>
      </div> --><!-- tab-content -->

      <div class="tab-pane ${my_tab_is_active ? "active" :""}" id="my_plan">
        <div id="group_editor_billing_rate_schedule_cards_container"></div>
      </div> <!-- tab-content -->


    
      <div class="tab-pane" id="payment_history">
        <div id='invoices_list'>
          <invoice-data
            group_id = ${this.recordId()}
          ></invoice-data>
        </div>
        <div id='invoice_viewer'></div>  
        <div id='rate_schedule_viewer'></div>  
      </div> <!-- tab-content -->


      <div class="tab-pane" id="usage_report">
        <div>
          <usage-report
            group_id = ${this.recordId()}
            plan_title='autoid plan 1'
            plan_amount=51534
            plan_interval='monthly'
          ></usage-report>
        </div>  
      </div> <!-- tab-content -->


      <div class="tab-pane" id="rate_schedules_tab">
        <h3>Rate Schedules</h3>
        <table id="group_rate_schedules" class="table vertical-middle well" style="width:100%">
          <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
          </thead>
        </table>
      </div>

      <div class="tab-pane ${! my_tab_is_active ? "active" :""}" id="billing_settings_tab">
        <div class="billing_section" style="margin-top: -20px">
          <h4>Billing Information</h4>
          ${this.is_admin ? `
          <div class="form-group">
            <label for="billing_type_id">Billing Type</label>
            <select id="billing_type_id" class="form-control">
              <option value="1" ${this.data.billing_type_id == 1 ? 'selected' : ''}>Bill group separately</option>
              <option value="2" ${this.data.billing_type_id == 2 ? 'selected' : ''}>Bill to parent group</option>
              ${this.is_admin ? `<option value="0" ${this.data.billing_type_id == 0 ? 'selected' : ''}>Do not Bill</option>` : ``}
            </select>
          </div>

          <div class="form-group">
            <label for="billing_day">Billing Day</label>
            <input 
              min='1'
              max='30'
              type='number'  
              id="billing_day" 
              class="form-control">
          </div>

          <div class="form-group">
            <label for="activation_date">Activation Date</label>
            <input 
              type='text' 
              id='activation_date' 
              autocomplete='off'
              class="form-control">
          </div>

          `: ``}

          <div class="form-group">
            <label for="billing_recipients">Billing Recipients</label>
            <p>Please seperate e-mail addresses by using a comma</p>
            <textarea 
              class='form-control'
              placeholder="eg.: one@example.com, two@example.com" 
              rows="5" 
              id="billing_recipients"></textarea>
          </div>
      </div>





          <div class='row hide' id="billing_fields_container">
            <div class="row">
              <div class="panel-body tab-content">
                <div class="page-content-wrap page-subtabs-item  tab-pane active" id="contacts_tab">
                  
                </div>
                <div class="page-content-wrap page-subtabs-item  tab-pane" id="callsource_billing_tab">
                  
                </div>
              </div>
            </div>
          </div>

          <div class='hide' id='old'>
            <h3>Billing Address</h3>

            <div class="form-group">
              <label for="address_1">Address 1</label>
              <input 
                type='text' 
                id='address_1' 
                autocomplete='off'
                class="form-control">
            </div>

            <div class="form-group">
              <label for="address_2">Address 2</label>
              <input 
                type='text' 
                id='address_2' 
                autocomplete='off'
                class="form-control">
            </div>

            <div class="form-group">
              <label for="city">City</label>
              <input 
                type='text' 
                id='city' 
                autocomplete='off'
                class="form-control">
            </div>

            <div class="form-group">
              <label for="state">State</label>
              <input 
                type='text' 
                id='state' 
                autocomplete='off'
                class="form-control">
            </div>

            <div class="form-group">
              <label for="zip">Zip</label>
              <input 
                type='text' 
                id='zip' 
                autocomplete='off'
                class="form-control">
            </div>

          </div> <!-- billing address end -->

          <div class="row update_bill_row">
            <br/>
            <a 
              class="btn btn-outline-primary" 
              id="update_billing_settings"
              >Update Billing Settings</a>
          </div>

       </div>

      

      <div class="tab-pane" id="payment_method_tab">
        <payment-methods
          groupId="${this.recordId()}"
        ></payment-methods>
      </div>
     `;

    const payment_method_tab_container = this.querySelector('#payment_method_tab');
    if (payment_method_tab_container) {
      payment_method_tab_container.innerHTML = ''
      if (is_stripe_customer) {
        payment_method_tab_container.appendChild(new PaymentMethods( this.recordId() ))
      }
      else {
        payment_method_tab_container.appendChild(new StripeCustomerSignup( this.recordId() ))
      }
    }
    
    await this.init();
  }

  recordId() {
    return document.getElementById('object_id').value
  }
  
  async init() {
    let group_id = this.recordId();

    // Open rate schedule edit page
    $('#group_rate_schedules tbody').on('click', 'tr td a.rate-schedule-edit', function (e) {
      let tr  = $(this).closest('tr')
      let row_data = $('#group_rate_schedules').DataTable().row(tr).data();
      document.querySelector('billing-manager').style.display = 'none';
      console.log('row_data: ' + JSON.stringify(row_data))
      let editPage = new RateScheduleEdit(row_data, group_id);
      (async () => {
        await editPage.init();
        document.querySelector('#billing_tab').appendChild(editPage)
        }
      )();
    });

    // Open view invoice page
    $('#group_invoices tbody').on('click', 'tr td a.view-invoice', function (e) {
      let tr  = $(this).closest('tr')
      let row_data = $('#group_invoices').DataTable().row(tr).data();
      // console.log('row_data: ' + JSON.stringify(row_data))
      const billing_invoice_id = e.currentTarget.getAttribute('data_invoice_id')
      document.getElementById('invoices_list').style.display = 'none';
      let invoiceViewer = new InvoiceViewer(billing_invoice_id);
      document.getElementById('invoice_viewer').innerHTML = '';
      document.getElementById('invoice_viewer').appendChild(invoiceViewer);
    });

    // search bar
    let user_table = $('#group_rate_schedules').DataTable();
    $('#user_table_search').keyup(function() {
      user_table.search($(this).val()).draw();
    })

    this.populateBillingData()
  }

  populateBillingData() {
    this.populateBillingTypes()
    
    let billing_day = document.getElementById('billing_day')
    if (billing_day) {
      billing_day.value = this.data.billing_day
    }

    let activation_date = document.getElementById('activation_date')
    if (activation_date) {
      if (this.data.activation_date !== null) {
        activation_date.value = moment(this.data.activation_date).format("MM/DD/YYYY")
      }
      else {
        activation_date.value = ''
      }
      this.init_date_picker()
    }
    
    let billing_recipients = document.getElementById('billing_recipients')
    if (billing_recipients) {
      billing_recipients.textContent = this.data.billing_recipients
    }

    $('#update_billing_settings').on('click', function(e){
      this.update_billing_settings()
    }.bind(this))

    this.render_rate_schedule_cards()

    document.addEventListener('billing_plan_changed', function(e){
      if (e.detail) {
        // used when only the collection has been updated
        if (e.detail.new_rate_schedule_group){
          this.data.selected_rate_schedule_id = e.detail.rate_schedule_id;
          this.data.selected_rate_schedule_group.rate_schedule_group_id = e.detail.new_rate_schedule_group.id;
          this.data.selected_rate_schedule_group.rate_schedule_group_name = e.detail.new_rate_schedule_group.name;
        }
        // used when a rate schedule has been selected
        else if (e.detail.rate_schedule_group){
          this.data.selected_rate_schedule_id = null;
          this.data.selected_rate_schedule_group.rate_schedule_group_id = e.detail.rate_schedule_group.id;
          this.data.selected_rate_schedule_group.rate_schedule_group_name = e.detail.rate_schedule_group.name;
        }

        this.render_rate_schedule_cards()
      }
    }.bind(this))
  }

  render_rate_schedule_cards() {
    const container = this.querySelector("#group_editor_billing_rate_schedule_cards_container")
    container.innerHTML = ''
    const rate_schedule_el = document.createElement('auto-group-rate-schedule-cards')
    rate_schedule_el.setAttribute('groupId', this.recordId())
    rate_schedule_el.setAttribute('showCurrentPlan', true)
    rate_schedule_el.setAttribute('selectedRateScheduleId', this.data.selected_rate_schedule_id)
    rate_schedule_el.setAttribute('selectedRateScheduleGroupId', this.data.selected_rate_schedule_group.rate_schedule_group_id)
    rate_schedule_el.setAttribute('selectedRateScheduleGroupName', this.data.selected_rate_schedule_group.rate_schedule_group_name)
    container.appendChild(rate_schedule_el)
  }
  
  init_date_picker() {
    $('#activation_date').daterangepicker({
      singleDatePicker: true,
      showDropdowns: true,
      autoUpdateInput: false,
      locale: {
          cancelLabel: 'Clear'
      },
      minDate: new Date(),
      minYear: new Date().getFullYear(),
      maxYear: parseInt(moment().format('YYYY'),10)
    });  

    $('#activation_date').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('MM/DD/YYYY'));
    });

    $('#activation_date').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
    });
  }

  update_billing_settings() {
    const group_id = this.data.id
    
    const group_addresses = this.querySelector('group-addresses')
    if (group_addresses){
      if (! group_addresses.validate()) {
        return
      }
    }      
    
    let billing_recipients = document.getElementById('billing_recipients').value;
    if(billing_recipients.length > 0 && !Common.validateCommaSeperatedEmail(billing_recipients)) {
      Common.notify("Email addresses not valid.", 'error');
      return
    }

    let addresses = {
      contact_address: null,
      billing_address: null
    };

    let contact_address = this.querySelector('.contact_address_container address-form')
    if (contact_address){
      addresses.contact_address = contact_address.getData();
      addresses.billing_address = !this.querySelector('#contact_address_checkbox').checked ? this.querySelector('.billing_address_container address-form').getData() : null
    }

    const post = {
      contact_address: addresses.contact_address,
      billing_address: addresses.billing_address
    }
    if (billing_recipients.length >0) {
      post.billing_recipients = billing_recipients
    }

    if(this.is_admin) {
      if (billing_day !== '') {
        post.billing_type_id = parseInt(document.getElementById('billing_type_id').value);
        post.billing_day = document.getElementById('billing_day').value;
        post.activation_date = moment(document.getElementById('activation_date').value);
      }
    }
    
    fetch(`/admin/groups/${group_id}/billing`,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(post)
    })
    .then( async (response) => {
      // get json response here
      let data = await response.json();
      
      if(response.status === 200){
        // Process data here
        if (data.success) {
          Common.notify("Updated billing successfully", "success");
        }
      }else{
        // Rest of status codes (400,500,303), can be handled here appropriately
        Common.notify(`Failed to update billing. ${data.error}`, "error");
      }
    })
    .catch((err) => {
      Common.notify(`Error updating billing. ${err}`, "error");
    })    
  }

  populateBillingTypes() {
    // console.log('options: ' + JSON.stringify(data.options))
    let select = document.getElementById('billing_type_id')
    if (!select) return


    select.addEventListener('change', function(e){
      const v = parseInt(e.target.value) 
      const showFlag = (v === 1)      
      this.showOrHideBillingFields(showFlag)
    }.bind(this))

    if (this.data.billing_type_id === 1) {
      this.showOrHideBillingFields(true)
    }
  }

  // Only populate the address fields once.
  populateAddressData(billing_type_id) {
    if(billing_type_id == 1 && ! this.populated_addresses) {
      this.populated_addresses = true
      let groupAddresses = new GroupAddresses(this.data);
      this.querySelector('#contacts_tab').appendChild(groupAddresses);
      if(this.data.cs_billing_info) {
        let callsourceBilling = new CallSourceBilling(this.data);
        this.querySelector('#callsource_billing_tab').appendChild(callsourceBilling);
      }

      const contact_save_el = this.querySelector('#contact_address_save')
      if (contact_save_el) {
        contact_save_el.remove()
      }
    }  
  }
  
  showOrHideBillingFields(showFlag=false) {
    this.populateAddressData(showFlag)
    let select = document.getElementById('billing_type_id')
    if (select){
      const billing_container_el = this.querySelector('#billing_fields_container')
      if (billing_container_el){
        if (showFlag){
          billing_container_el.classList.remove('hide')
        }
        else {
          billing_container_el.classList.add('hide')
        }
      }

    }
  }

}

customElements.define("billing-manager", BillingManager)